import React from 'react';

import classNames from 'classnames';

import Dropdown from './index';

import './styles.scss';

interface Props {
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
  label?: string;
  sticky?: boolean;
}

// Dropdowns and sticky cells don't play nice by default
// This combines the two with some preset props/overrides to make them nicer
export default function DropdownCell({
  children,
  className,
  disabled,
  icon,
  label,
  sticky = true,
  ...props
}: Props) {
  return (
    <td
      className={classNames('dropdown__cell', className, {
        'dropdown__cell--sticky': sticky,
        'sticky-cell end-cell': sticky,
      })}
      {...props}
    >
      <Dropdown
        align="start"
        disabled={disabled}
        drop="start"
        icon={icon}
        label={label}
      >
        {children}
      </Dropdown>
    </td>
  );
}
